// extracted by mini-css-extract-plugin
export var borderRadius = "_5k-4";
export var large = "_5k-3";
export var logoContainer = "_5k-0";
export var nameLogo = "_5k-2";
export var small = "_5k-1";